export default __webpack_public_path__ + "static/media/thumbnail_ascend.89aff802.png";